<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' ,fullScreenBackdrop:true}"></ngx-loading>
<div class="wrapper">
    <app-sidebar></app-sidebar>
    <app-header></app-header>
    <div class="page-wrapper">
        <div class="page-content">
            <div class="page-breadcrumb d-sm-flex align-items-center mb-4">
               <!-- <div class="breadcrumb-title pe-3" *ngIf="currentUrl=='/demographic'"><span [translate]="'GREATER.DEMOGRAPHIC'"> </span></div> -->
                <div class="ps-3">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb mb-0 p-0">
                            <li class="breadcrumb-item"><a href="javascript:void(0);" routerLink="/dashboard" ><i class="bx bx-home-alt"></i></a>
                            </li>
                            <!-- <li class="breadcrumb-item active" aria-current="page" *ngIf="currentUrl=='/demographic'"><span [translate]="'GREATER.DEMOGRAPHIC'"> </span></li> -->

                        </ol>
                    </nav>
                </div>
                <div class="ms-auto">
                    <div class="btn-group ms-2" role="group">                       
                    </div>
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <table class="table mb-0 table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col"><span [translate]="'GREATER.NO'"> </span>.</th>
                                        <th scope="col"><span [translate]="'GREATER.NAME'"> </span></th>
                                        <!-- <th scope="col"><span [translate]="'GREATER.YEAR_RANGE'"> </span></th> -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of dataListing; let i = index ">
                                        <td scope="row">{{ i + 1 }}</td>
                                        <td>{{item.name}}</td>       
                                        <!-- <td>{{item.name}}</td>                                         -->
                                    </tr>
                                </tbody>
                            </table>

                            <!-- <div class="pagination-block pt-5">
                                <pagination-controls [previousLabel]="previousLabel" [nextLabel]="nextLabel" (pageChange)="getDetail((p = $event))" id='all' class="text-center" *ngIf="dataListing.length > 0"></pagination-controls>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <app-footer></app-footer>
</div>